import { IconComfortBabyChair16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortBabyChair.js';
import { IconComfortBabyCrib16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortBabyCrib.js';
import { IconComfortBanya16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortBanya.js';
import { IconComfortBath16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortBath.js';
import { IconComfortBathroomAccessories16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortBathroomAccessories.js';
import { IconComfortBedSheets16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortBedSheets.js';
import { IconComfortCoffeeMachine16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortCoffeeMachine.js';
import { IconComfortConditioner16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortConditioner.js';
import { IconComfortCondy16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortCondy.js';
import { IconComfortDishwasher16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortDishwasher.js';
import { IconComfortElevator16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortElevator.js';
import { IconComfortEquipment16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortEquipment.js';
import { IconComfortFireplace16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortFireplace.js';
import { IconComfortFridge16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortFridge.js';
import { IconComfortGameConsole16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortGameConsole.js';
import { IconComfortGarage16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortGarage.js';
import { IconComfortHairDryer16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortHairDryer.js';
import { IconComfortIron16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortIron.js';
import { IconComfortKitchen16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortKitchen.js';
import { IconComfortRadiator16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortRadiator.js';
import { IconComfortRobe16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortRobe.js';
import { IconComfortShower16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortShower.js';
import { IconComfortSlippers16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortSlippers.js';
import { IconComfortTV16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortTV.js';
import { IconComfortTeaPot16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortTeaPot.js';
import { IconComfortTowel16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortTowel.js';
import { IconComfortTvBox16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortTvBox.js';
import { IconComfortVentilation16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortVentilation.js';
import { IconComfortVeranda16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortVeranda.js';
import { IconComfortWasher16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortWasher.js';
import { IconComfortWaterHeater16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortWaterHeater.js';
import { IconComfortWiFi16 } from '@cian/ui-kit-design-tokens/icons/comfort/16/ComfortWiFi.js';
import { IconFunctionalLock16 } from '@cian/ui-kit-design-tokens/icons/functional/16/FunctionalLock.js';
import { IconInfrastructureBarbecue16 } from '@cian/ui-kit-design-tokens/icons/infrastructure/16/InfrastructureBarbecue.js';
import { IconInfrastructureFitness16 } from '@cian/ui-kit-design-tokens/icons/infrastructure/16/InfrastructureFitness.js';
import { IconInfrastructureJacuzzi16 } from '@cian/ui-kit-design-tokens/icons/infrastructure/16/InfrastructureJacuzzi.js';
import { IconInfrastructureOffice16 } from '@cian/ui-kit-design-tokens/icons/infrastructure/16/InfrastructureOffice.js';
import { IconInfrastructureParking16 } from '@cian/ui-kit-design-tokens/icons/infrastructure/16/InfrastructureParking.js';
import { IconInfrastructurePool16 } from '@cian/ui-kit-design-tokens/icons/infrastructure/16/InfrastructurePool.js';
import { IconInfrastructureRestaurant16 } from '@cian/ui-kit-design-tokens/icons/infrastructure/16/InfrastructureRestaurant.js';
import { IconInfrastructureSauna16 } from '@cian/ui-kit-design-tokens/icons/infrastructure/16/InfrastructureSauna.js';
import { IconMediaSoundOff16 } from '@cian/ui-kit-design-tokens/icons/media/16/MediaSoundOff.js';
import { IconViewCity16 } from '@cian/ui-kit-design-tokens/icons/view/16/ViewCity.js';
import { IconViewMountains16 } from '@cian/ui-kit-design-tokens/icons/view/16/ViewMountains.js';
import { IconViewNoneWindow16 } from '@cian/ui-kit-design-tokens/icons/view/16/ViewNoneWindow.js';
import { IconViewSea16 } from '@cian/ui-kit-design-tokens/icons/view/16/ViewSea.js';
import { IconViewStreet16 } from '@cian/ui-kit-design-tokens/icons/view/16/ViewStreet.js';
import * as React from 'react';

import type { ISVGIconProps } from '@cian/ui-kit-design-tokens/internal';

export type TAmenityIcon = React.FC<ISVGIconProps>;

const amenityIcons = new Map<string, TAmenityIcon>([
  ['microwave', IconComfortEquipment16],
  ['coffeeMaker', IconComfortCoffeeMachine16],
  ['kitchen', IconComfortKitchen16],
  ['kitchenware', IconInfrastructureRestaurant16],
  ['fridge', IconComfortFridge16],
  ['teapot', IconComfortTeaPot16],
  ['dishwasher', IconComfortDishwasher16],
  ['linen', IconComfortBedSheets16],
  ['safe', IconFunctionalLock16],
  ['internet', IconComfortWiFi16],
  ['desk', IconInfrastructureOffice16],
  ['bath', IconComfortBath16],
  ['shower', IconComfortShower16],
  ['dailyrentShower', IconComfortShower16],
  ['freeToiletries', IconComfortBathroomAccessories16],
  ['waterHeater', IconComfortWaterHeater16],
  ['whirlpool', IconInfrastructureJacuzzi16],
  ['towels', IconComfortTowel16],
  ['slippers', IconComfortSlippers16],
  ['sauna', IconInfrastructureSauna16],
  ['privateBathroom', IconComfortBath16],
  ['washing', IconComfortWasher16],
  ['hairdryer', IconComfortHairDryer16],
  ['bathrobe', IconComfortRobe16],
  ['ironAndIroningFacilities', IconComfortIron16],
  ['tv', IconComfortTV16],
  ['gameConsole', IconComfortGameConsole16],
  ['cableTelevision', IconComfortTvBox16],
  ['gym', IconInfrastructureFitness16],
  ['babyBed', IconComfortBabyCrib16],
  ['feedingChair', IconComfortBabyChair16],
  ['cond', IconComfortConditioner16],
  ['fan', IconComfortVentilation16],
  ['soundproofing', IconMediaSoundOff16],
  ['fireplace', IconComfortFireplace16],
  ['heating', IconComfortRadiator16],
  ['yardView', IconViewCity16],
  ['cityView', IconViewCity16],
  ['mountainView', IconViewMountains16],
  ['seaView', IconViewSea16],
  ['streetView', IconViewStreet16],
  ['noView', IconViewNoneWindow16],
  ['bathhouse', IconComfortBanya16],
  ['barbequeGrills', IconInfrastructureBarbecue16],
  ['pool', IconInfrastructurePool16],
  ['garage', IconComfortGarage16],
  ['parking', IconInfrastructureParking16],
  ['freeParking', IconInfrastructureParking16],
  ['paidParking', IconInfrastructureParking16],
  ['terrace', IconComfortVeranda16],
  ['lift', IconComfortElevator16],
  ['elevator', IconComfortElevator16],
  ['freightElevator', IconComfortCondy16],
]);

export function getAmenityIcon(theme?: string | null): TAmenityIcon | null {
  if (!theme) {
    return null;
  }

  const icon = amenityIcons.get(theme);

  if (!icon) {
    return null;
  }

  return icon;
}
